<template>
  <div class="diamond" v-bind:style="{minWidth: getSize(), minHeight: getSize(), background: getCategoryColor(this.tagText)}">

  </div>
</template>

<script>
import CategoryColor from "@/mixins/CategoryColor";

export default {
  name: "DiamongTag",
  props:{
    tagText:{
      type: String,
      default: "null"
    },
    size:{
      type: Number,
      default: 10
    }
  },
  methods:{
    getSize(){
      return this.size + "px";
    }
  },
  mixins:[CategoryColor]
}
</script>

<style scoped>

.diamond{
  min-width: 10px;
  min-height: 10px;
  transform: rotate(45deg);
}

</style>